import { StatsManager } from '../utils'

export class StatsController
{
  private statsManager: StatsManager
  private hideTimeout: number | null = null
  private currentHoveredContainerId: string | null = null

  constructor(statsPanel: HTMLElement)
  {
    this.statsManager = new StatsManager()
    this.statsManager.initialize(statsPanel)
  }

  public setupContainerHoverEvents(
    container: HTMLElement,
    containerId: string,
    getContainerStats: () => any,
    showGlobalStats: () => void,
    isAnyContainerDragging: () => boolean
  ): void {
    let isMouseOverContainer = false

    container.addEventListener('mouseenter', () => {
      isMouseOverContainer = true

      this.cancelHideTimeout()
      this.showContainerStats(containerId, getContainerStats)
    })

    container.addEventListener('mouseleave', (e) => {
      isMouseOverContainer = false

      const relatedTarget = e.relatedTarget as HTMLElement
      if (relatedTarget && container.contains(relatedTarget)) {
        return
      }
      if (isAnyContainerDragging()) {
        return
      }

      this.scheduleHideStats(showGlobalStats)
    })

    container.addEventListener('click', () => {
      if (isMouseOverContainer) {
        this.cancelHideTimeout()
        this.showContainerStats(containerId, getContainerStats)
      }
    })

    container.addEventListener('mousemove', () => {
      if (isMouseOverContainer) {
        this.cancelHideTimeout()
      }
    })
  }

  private cancelHideTimeout(): void
  {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  private scheduleHideStats(showGlobalStats: () => void): void
  {
    this.cancelHideTimeout()

    this.hideTimeout = window.setTimeout(() => {
      showGlobalStats()
      this.currentHoveredContainerId = null
    }, 100)
  }

  public showContainerStats(containerId: string, getContainerStats: () => any): void
  {
    if (this.currentHoveredContainerId === containerId) return

    const containerStats = getContainerStats()
    this.statsManager.showContainerStats(containerStats)
    this.currentHoveredContainerId = containerId
  }

  public showGlobalStats(getGlobalStats: () => any): void
  {
    this.statsManager.showGlobalStats(getGlobalStats())
    this.currentHoveredContainerId = null
  }

  public updateStats(getGlobalStats: () => any): void
  {
    this.statsManager.showGlobalStats(getGlobalStats())
  }
}
